export default __webpack_public_path__ + "static/builder-hog-697c3525c0f4e0ee60ad0777aeb44274.png";